import Card from "../UI/Card";
import CardToggle from "../UI/CardToggle";
import Button from "../UI/Button";
import { useModal } from "../../hooks/use-modal.jsx";
import { useState } from "react";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import {
  COURRIER_INITIAL_VALUE,
  courrierValidationSchema,
} from "../../models/courrier";
import useCourriers from "../../hooks/use-courriers";
import CourrierForm from "./CourrierForm";

export default function CourrierShow({ type }) {
  const { courriers, updateCourrier, addCourrier } = useCourriers(type, true);
  const [FormModal, closeForm, openForm] = useModal();
  const [courrierToEdit, setcourrierToEdit] = useState();
  const [isCreating, setIsCreating] = useState(false);

  const defaultValues = { ...COURRIER_INITIAL_VALUE, type };
  let initialValues = toInitialValuesFromSchema(
    courrierValidationSchema,
    courrierToEdit,
    defaultValues,
  );

  async function submitHandler(values) {
    const sanitizedValues = sanitizeValues(values);
    try {
      if (isCreating) {
        await addCourrier(sanitizedValues);
      } else if (courrierToEdit) {
        await updateCourrier(courrierToEdit.id, sanitizedValues);
      }
      closeForm();
      setIsCreating(false);
      setcourrierToEdit(null);
    } catch (error) {
      console.error(error);
    }
  }

  function handleAdd() {
    setcourrierToEdit(null);
    setIsCreating(true);
    openForm();
  }

  function handleEdit(courrier) {
    setcourrierToEdit(courrier);
    setIsCreating(false);
    openForm();
  }

  return (
    <>
      <FormModal>
        <CourrierForm
          initialValues={initialValues}
          onSubmit={submitHandler}
          isCreating={isCreating}
        />
      </FormModal>
      <div className="marginB10">
        <Button onClick={handleAdd}>Ajouter</Button>
      </div>
      {courriers.map((courrier, i) => (
        <Card className={"marginB10"} key={i}>
          <div className={"flex space-between align-items-center"}>
            <div className={"flex gap10"}>
              {courrier.is_habitation && (
                <Button variant="secondary" disabled>
                  Habitation
                </Button>
              )}
              {courrier.is_commercial && (
                <Button variant="secondary" disabled>
                  Commercial
                </Button>
              )}
              {courrier.is_autre_local && (
                <Button variant="secondary" disabled>
                  Autre local
                </Button>
              )}
            </div>
            <div>
              {courrier.status !== 1 && (
                <Button variant="secondary" disabled className={"marginR10"}>
                  Brouillon
                </Button>
              )}
              <Button onClick={() => handleEdit(courrier)}>Modifier</Button>
            </div>
          </div>

          <CardToggle
            title={
              <span className={"primaryText"}>
                {courrier.static_id} - {courrier.nom}
              </span>
            }
          >
            <div dangerouslySetInnerHTML={{ __html: courrier.content }} />
          </CardToggle>
        </Card>
      ))}
    </>
  );
}
